import { useState } from "react";
import { toast } from "sonner";
import { Section, Container, Eyebrow, DisplayH1 } from "@/components/Layout";
import { api } from "@/lib/api";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "General inquiry", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/contact", form); toast.success("Message received."); setForm({ ...form, name: "", email: "", message: "" }); }
    catch { toast.error("Message failed to send."); }
    finally { setBusy(false); }
  };

  return (
    <Section testid="contact-page" className="pt-40 pb-32">
      <Container>
        <div className="grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <Eyebrow>Get in touch</Eyebrow>
            <DisplayH1 className="mt-6">The University is listening.</DisplayH1>
            <div className="mt-10 space-y-5 text-sm">
              <div className="flex items-center gap-4"><Mail size={16} className="text-[color:var(--wk-gold)]" /> admissions@wolfkeeper.edu</div>
              <div className="flex items-center gap-4"><Phone size={16} className="text-[color:var(--wk-gold)]" /> +1 (312) 555 · WOLF</div>
              <div className="flex items-center gap-4"><MapPin size={16} className="text-[color:var(--wk-gold)]" /> 800 N Lake Shore Dr · Chicago</div>
            </div>
          </div>
          <form onSubmit={submit} className="lg:col-span-7 space-y-8" data-testid="contact-form">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <label className="overline">Name</label>
                <input required value={form.name} onChange={set("name")} className="w-full bg-transparent border-b border-white/20 focus:border-[color:var(--wk-gold)] outline-none py-3 text-lg" data-testid="contact-name" />
              </div>
              <div>
                <label className="overline">Email</label>
                <input required type="email" value={form.email} onChange={set("email")} className="w-full bg-transparent border-b border-white/20 focus:border-[color:var(--wk-gold)] outline-none py-3 text-lg" data-testid="contact-email" />
              </div>
            </div>
            <div>
              <label className="overline">Subject</label>
              <input required value={form.subject} onChange={set("subject")} className="w-full bg-transparent border-b border-white/20 focus:border-[color:var(--wk-gold)] outline-none py-3 text-lg" data-testid="contact-subject" />
            </div>
            <div>
              <label className="overline">Message</label>
              <textarea required rows={5} value={form.message} onChange={set("message")} className="w-full bg-transparent border-b border-white/20 focus:border-[color:var(--wk-gold)] outline-none py-3 text-lg resize-none" data-testid="contact-message" />
            </div>
            <button disabled={busy} className="btn-gold" data-testid="contact-submit">{busy ? "Sending…" : "Send message"}</button>
          </form>
        </div>
      </Container>
    </Section>
  );
}
